import styled, { createGlobalStyle } from "styled-components";

import TheMixSemiLightWoff from "./assets/fonts/the-mix-c5-semilight.woff";
import TheMixSemiLightWoff2 from "./assets/fonts/the-mix-c5-semilight.woff2";
import TheMixExtraBoldWoff from "./assets/fonts/the-mix-c5-extrabold.woff";
import TheMixExtraBoldWoff2 from "./assets/fonts/the-mix-c5-extrabold.woff2";

import BackgroundImage from "./assets/background.jpg";

import { appColors } from "./config/colors";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "TheMixSemilight";
    font-style: normal;
    font-weight: 400;
    src: local(""),
      url(${TheMixSemiLightWoff}) format("woff2"), 
      url(${TheMixSemiLightWoff2}) format("woff"); 
  }

  @font-face {
    font-family: "TheMixExtraBold";
    font-style: normal;
    font-weight: 700;
    src: local(""),
      url(${TheMixExtraBoldWoff}) format("woff2"), 
      url(${TheMixExtraBoldWoff2}) format("woff"); 
  }

  html {
    box-sizing: border-box;
    background-color: ${appColors.backgroundPrimary};
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  p {
    display: block;
    max-width: 200px;
  }

  html,
  body {
    margin: 0;
    padding: 0;
  }

  body {
    position: relative;
    overflow: hidden;

    font-family: "TheMixSemilight", sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: ${appColors.fontPrimary};
    
    background-image: url(${BackgroundImage});
    background-repeat: no-repeat;
    background-position: center 0;

    @media (min-width: 1200px) {
      background-size: 100%;
    }
  }

  main {
    display: block;
    padding: 35px 0 50px;
  }

  p {
    margin-top: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Title = styled.h2`
  font-family: "TheMixExtraBold", sans-serif;
  font-weight: 700;
  font-size: 40px;
  text-transform: uppercase;
  text-align: center;
  text-shadow: 0 0 20px rgb(25 58 63 / 50%);
  line-height: 1;
  margin-top: 0;
  color: ${appColors.headlinePrimary};
`;
